import Phaser from 'phaser';
import { DOOR_FRAME_UP, DOOR_FRAME_DOWN } from '../tileFrames';
import { TILE } from '../balance';

/** 门的两个方向：up = 返回上一层，down = 前往下一层 */
export type DoorDirection = 'up' | 'down';

export default class Door extends Phaser.Physics.Arcade.Image {
  readonly direction: DoorDirection;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    direction: DoorDirection = 'down'
  ) {
    // 使用 tileset spritesheet 中的木门帧（带石框纹理，素材 16×16）
    const frame = direction === 'up' ? DOOR_FRAME_UP : DOOR_FRAME_DOWN;
    super(scene, x, y, 'tileset', frame);
    this.direction = direction;
    scene.add.existing(this);
    scene.physics.add.existing(this, true);
    this.setOrigin(0.5, 0.5);
    this.setDisplaySize(TILE, TILE);
    // 与 Wall 同理：撤销显示尺寸后需同步静态碰撞盒（与视觉一致）
    (this.body as Phaser.Physics.Arcade.StaticBody).updateFromGameObject();
    this.setImmovable(true);
    // 不再使用 setTint，保留原始纹理；上锁状态用 alpha 表示
  }
}
